import { forwardRef } from '@chakra-ui/react-v2';

import {
  ButtonGroup,
  type ButtonGroupProps,
} from '@frontend/legacy-components';

export type ModalButtonGroupProps = ButtonGroupProps;

export const ModalButtonGroup = forwardRef<ModalButtonGroupProps, 'div'>(
  ({ size = 'lg', justifyContent = 'end', ...restProps }, ref) => {
    return (
      <ButtonGroup
        ref={ref}
        size={size}
        justifyContent={justifyContent}
        {...restProps}
      />
    );
  },
);
ModalButtonGroup.displayName = 'ModalButtonGroup';
